/* eslint-disable @typescript-eslint/no-explicit-any */
import { ITradeUnionMember } from 'app/api/tradeUnionMembers/model'
import R from 'app/assets/R'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { BaseModalComponent } from 'app/components/common/ModalComponent'
import { SectionBase } from 'app/components/common/SectionBase'
import HeaderPage from 'app/components/header/components/HeaderPage'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import { convertColumnTable } from 'app/components/tables/BaseTableReport/hook'
import { convertedVariables } from 'app/styles/themes/themeVariables'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CreateTumModal, FilterLayout, SyncFromUehModal } from './components'
import { IResponseDataPromise, StatusPromiseEnum, useHook } from './hook'
import * as S from './styles'
const TEMPLATE_IMPORT_TUM = process.env.TEMPLATE_IMPORT_TUM ?? '#'

const TradeUnionMemberManagement: React.FC = () => {
  const { t } = useTranslation()
  const {
    columns,
    pagination,
    filter,
    onChangeFilter,
    handleChangePagination,
    isLoading,
    data,
    isPermissionCreate,
    isPermissionSyncFromUeh,
    downloadExcel,
    isPermissionDownload,
    onPressImport,
    refResult,
    responseImport,
    isLoadingImport,
    setResponseImport,
  } = useHook()

  return (
    <S.ScrollWrapper>
      <HeaderPage
        titleI18nKey={R.strings.trade_union_members_management}
        rightComponent={
          isPermissionCreate || isPermissionSyncFromUeh ? (
            <>
              {isPermissionCreate ? (
                <>
                  <BaseCol>
                    <CreateTumModal />
                  </BaseCol>
                </>
              ) : null}

              {isPermissionSyncFromUeh ? (
                <BaseCol>
                  <SyncFromUehModal />
                </BaseCol>
              ) : null}
            </>
          ) : undefined
        }
        isExport={isPermissionDownload}
        onPressExport={downloadExcel}
        isImport={isPermissionCreate}
        urlExample={TEMPLATE_IMPORT_TUM}
        nameFileExample="Danh_sach_doan_vien_template.xlsx"
        onPressImport={onPressImport}
        isLoadingImport={isLoadingImport}
      />

      <SectionBase>
        <BaseSpace size={0}>
          <FilterLayout filter={filter} onChangeFilter={onChangeFilter} />
          <BaseTableManagement
            columns={columns}
            dataSource={data}
            pagination={{
              ...pagination,
              total: pagination.total,
              showTotal: total => (
                <BaseText children={`Tổng: ${total}`} fontWeight="bold" />
              ),
              showSizeChanger: true,
            }}
            loading={isLoading}
            onChange={handleChangePagination}
            rowClassName="row-overwrite-style"
          />

          <BaseModalComponent
            titleModal={'Kết quả import'}
            buttonOpenModal={<BaseCol />}
            widthModal={900}
            ref={refResult}
            showCancelButton={false}
            handleSubmit={() => {
              setResponseImport([])
              refResult?.current?.hide?.()
            }}
            renderContent={
              <BaseSpace>
                <BaseTableManagement
                  columns={[
                    convertColumnTable<any>({
                      key: 'fullName',
                      title: t(R.strings.full_name),
                      fixed: 'left',
                      render: (
                        _,
                        row: IResponseDataPromise<ITradeUnionMember>,
                      ) => {
                        return (
                          <BaseText
                            fontWeight="semibold"
                            children={row?.record?.fullName ?? '-'}
                            style={{ color: getColorByStatus(row?.status) }}
                          />
                        )
                      },
                    }),
                    convertColumnTable<any>({
                      key: 'mql',
                      title: t(R.strings.id_management),
                      render: (
                        _,
                        row: IResponseDataPromise<ITradeUnionMember>,
                      ) => {
                        return (
                          <BaseText
                            fontWeight="semibold"
                            children={row?.record?.mql ?? '-'}
                            style={{ color: getColorByStatus(row?.status) }}
                          />
                        )
                      },
                    }),
                    convertColumnTable<any>({
                      key: 'email',
                      title: t(R.strings.email),
                      render: (
                        _,
                        row: IResponseDataPromise<ITradeUnionMember>,
                      ) => {
                        return (
                          <BaseText
                            fontWeight="medium"
                            opacity="0.7"
                            style={{ color: getColorByStatus(row?.status) }}
                            children={row?.record?.email ?? '-'}
                          />
                        )
                      },
                    }),
                    convertColumnTable<any>({
                      key: 'dienThoaiDiDong',
                      title: t(R.strings.phone),
                      render: (
                        _,
                        row: IResponseDataPromise<ITradeUnionMember>,
                      ) => {
                        return (
                          <BaseText
                            fontWeight="medium"
                            opacity="0.7"
                            style={{ color: getColorByStatus(row?.status) }}
                            children={row?.record?.dienThoaiDiDong ?? '-'}
                          />
                        )
                      },
                    }),
                    convertColumnTable<any>({
                      key: 'reason',
                      title: 'Lý do thất bại (nếu có)',
                      render: (
                        _,
                        row: IResponseDataPromise<ITradeUnionMember>,
                      ) => {
                        return (
                          <BaseText
                            fontWeight="medium"
                            opacity="0.7"
                            style={{ color: getColorByStatus(row?.status) }}
                            children={
                              row?.status === StatusPromiseEnum.FULFILLED
                                ? ''
                                : row?.reason?.message
                            }
                          />
                        )
                      },
                    }),
                    convertColumnTable<any>({
                      key: 'status',
                      title: 'Trạng thái',
                      render: (
                        _,
                        row: IResponseDataPromise<ITradeUnionMember>,
                      ) => {
                        return (
                          <BaseText
                            fontWeight="medium"
                            opacity="0.7"
                            style={{ color: getColorByStatus(row?.status) }}
                            children={
                              row?.status === StatusPromiseEnum.FULFILLED
                                ? 'Thành công'
                                : 'Thất bại'
                            }
                          />
                        )
                      },
                    }),
                  ]}
                  dataSource={responseImport}
                  pagination={false}
                  rowClassName="row-overwrite-style"
                  scroll={{
                    x: true,
                  }}
                />
              </BaseSpace>
            }
          />
        </BaseSpace>
      </SectionBase>
    </S.ScrollWrapper>
  )
}

export default TradeUnionMemberManagement

const getColorByStatus = (status: StatusPromiseEnum) => {
  switch (status) {
    case StatusPromiseEnum.REJECTED:
      return convertedVariables.statesRedColor
    case StatusPromiseEnum.FULFILLED:
      return convertedVariables.statesGreenColor
  }
}
